module.exports = __webpack_public_path__ + "img/en-US.f5133317.png";